window.channeldata2 = [];
window.page2 = 1;
window.size2 = 15;

window.gethotest2 = function (total) {
    size2 = total;
    getlives2();
};

window.getlives2 = function () {
    showWait();
    $.ajax({
        type: 'get',
        async: true,
        url: ROOT + '/lives/search?page=' + page2 + '&size=' + 15 + '&type=' + 1,
        data: {},
        contentType: 'application/json',
        dataType: 'json',
        success: function (result) {
            if (result) {
                if (result.error == undefined) {
                    channeldata2 = result.data;
                    createliveinfo2();
                } else {
                    // alert(result.message);
                }
            }
        },
        error: function (XMLHttpRequest, textStatus, errorThrown) {
            // alert(XMLHttpRequest.responseText);
        },
        complete: function (XMLHttpRequest, textStatus) {
            hideWait();

            if (channeldata2.length == 0) {
                $('.loadmore2').hide();
                $('.loadinfo2').show();
            } else {
                $('.loadmore2').show();
                $('.loadinfo2').hide();
                page2++;
            }
        }
    });
};

window.createliveinfo2 = function () {
    for (var i = 0; i < channeldata2.length; i++) {
        var info = channeldata2[i];

        var date = new Date(info.start_time * 1000);
        var creationTime = dateFormat(date, 'yyyy-MM-dd');
        // var creation_time = getdaysdiff(date);

        var type = info.type;

        var targetHtml = '';
        if (info.state == 3) {
            if (info.type == 1) {
                targetHtml = '<a target="_blank" href="' + ROOT + '/playbacks/' + info.id + '">';
            } else {
                targetHtml = '<a target="_blank" href="' + ROOT + '/playbacks/' + info.id + '">';
            }
        } else {
            targetHtml = '<a target="_blank" href="' + ROOT + '/room/' + info.id + '">';
        }

        var typeText = '';
        if (info.state == 3) {
            typeText = '回放';
        } else if (info.state == 2) {
            typeText = '正在直播';
        } else if (info.state == 1) {
            typeText = '预告';
        }

        var avatar = '';
        if (info.owner_avatar_url && info.owner_avatar_url.length > 0) {
            avatar = '<img src="' + info.owner_avatar_url + '?w=38&h=38&s=3">';
        }

        var html =
            '<div class="liveinfo2">' +
            targetHtml +
            '<div class="liveinfo-img">' +
            ((info.cover_url && info.cover_url.length > 0) ?
                '<img src="' + info.cover_url + '?w=180&h=180&s=3">' : '<div class="img-none"></div>') +
            '<div class="liveinfo-type liveinfo-type-' + info.state + '">' +
            '<div class="liveinfo-type-wrap">' +
            '<div class="liveinfo-type-bg"></div>' +
            '<div class="liveinfo-type-text">' + typeText + '</div>' +
            '</div>' +
            '</div>' +
            '<div class="liveinfo-hover"></div>' +
            '</div>' +
            '<div class="liveinfo-title">' +
            '<div class="liveinfo-user-img">' +
            avatar +
            '</div>' +
            '<div class="liveinfo-title-name">' + info.title + '</div>' +
            '</div>' +
            '<div class="liveinfo-user">' +
            // '<div class="liveinfo-user-islive">' + (info.state == 3 ? '回放' : '正在直播') + '</div>' +
            '<div class="liveinfo-user-name">' + info.owner_nickname + '</div>' +
            '<div class="liveinfo-user-visitcount">' + info.current_visitor_count + '人参与</div>' +
            '</div>' +
            '</a>' +
            '</div>';
        $('.livelist2').append(html);
    }
};

$('.loadmore2').click(function () {
    gethotest2(size);
    // scrollbuttom();
});

window.num2 = 1; // 计数器初始化为1
window.maxnum2 = 1000; // 设置一共要加载几次
$(window).scroll(function () {
    if ($('.loadmore2').length > 0 && $('.curentlives2').css('display') == 'block') {
        checkload2();
    }
});

window.checkload2 = function () {

    var srollPos = $(window).scrollTop(); // 滚动条距离顶部的高度

    var windowHeight = $(window).height(); // 窗口的高度

    var dbHiht = $('body').height(); // 整个页面文件的高度

    setTimeout(function () {
        if ((windowHeight + srollPos) >= (dbHiht) && num2 != maxnum2) {
            gethotest2(size2);
            num++; // 计数器+1
        }

    }, 100);
};